export const TokenSectionHeader = () => (
    <div className="sds_example__column-container">
        <div style={{ width: '25%' }} className="sds_example__column-header">
            Variable Name
        </div>
        <div style={{ width: '25%' }} className="sds_example__column-header">
            Example
        </div>
        <div style={{ width: '25%' }} className="sds_example__column-header">
            Value
        </div>
        <div style={{ width: '25%' }} className="sds_example__column-header">
            Uses
        </div>
    </div>
);
